(() => {
  const root = document.documentElement;
  const revealSelector = '.oneshot-reveal';

  if (!('IntersectionObserver' in window)) {
    root.classList.remove('js');
    return;
  }

  try {
    const observed = new WeakSet();

    // Chi resta sopra il bordo alto del viewport non riceve piu' nessuna intersezione:
    // succede saltando con la barra di scorrimento, tornando indietro o arrivando
    // su un'ancora. Quegli elementi vanno mostrati, non lasciati invisibili.
    const revealPassed = () => {
      document.querySelectorAll(revealSelector).forEach((element) => {
        if (element.classList.contains('is-in')) return;
        if (element.getBoundingClientRect().bottom >= 0) return;
        element.classList.add('is-in');
        observer.unobserve(element);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
        revealPassed();
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    const observeReveals = (scope) => {
      scope.querySelectorAll(revealSelector).forEach((element) => {
        if (observed.has(element)) return;
        observed.add(element);
        observer.observe(element);
      });
    };

    observeReveals(document);
    window.addEventListener('load', revealPassed, { once: true });
    window.addEventListener('hashchange', () => window.setTimeout(revealPassed, 300));
    document.addEventListener('shopify:section:load', (event) => observeReveals(event.target));
    root.dataset.oneshotFirmaReady = 'true';
  } catch (error) {
    root.classList.remove('js');
  }
})();
